import { withNativeProps } from '@/utils/with-native-props';
import React from 'react';
export const CnSliderItem = (props) => {
    return withNativeProps(props, React.createElement("div", { className: "cn-ui-m-slider-item", onClick: props.onClick }, props.children));
};
